import { RcClasses } from '../../../foundation';
export var RcTablePaginationClasses = RcClasses([
    'root',
    'toolbar',
    'spacer',
    'menuItem',
    'caption',
    'input',
    'selectRoot',
    'select',
    'selectIcon',
    'actions',
], 'RcTablePagination');
export function defaultGetAriaLabel(value) {
    return "Go to " + value + " page";
}
export function defaultLabelDisplayedRows(_a) {
    var from = _a.from, to = _a.to, count = _a.count;
    return from + "-" + to + " of " + (count !== -1 ? count : "more than " + to);
}
export var defaultLabelOfPage = function (_a) {
    var totalPage = _a.totalPage;
    return "of " + totalPage + " pages";
};
